import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="policy-page page-shell section-space">
      <header><p className="eyebrow">Simple and considered</p><h1>Returns & refunds</h1><p>We hope every piece feels right in your hands. If it does not, you may request a return within 30 days of delivery.</p></header>
      <div className="policy-layout">
        <nav aria-label="On this page"><strong>At a glance</strong><span>30-day return window</span><span>Unused, original condition</span><span>Proof of purchase required</span><Link to="/contact">Start a return</Link></nav>
        <article>
          <section><h2>Return eligibility</h2><p>Products must be unused, unmarked and returned with original packaging. Opened ink, personalised goods, gift cards and clearance items cannot normally be returned unless faulty.</p></section>
          <section><h2>How to start a return</h2><ol><li>Email {siteConfig.contact.email} with your order number and the item you wish to return.</li><li>Wait for return instructions and the correct return address.</li><li>Pack the item securely and use a tracked service.</li></ol></section>
          <section><h2>Refunds</h2><p>Once inspected, approved refunds are issued to the original payment method. Bank processing can take 5–10 working days. Original shipping fees are not refundable unless the order was faulty or incorrect.</p></section>
          <section><h2>Damaged or incorrect items</h2><p>Please contact us within seven days and include a clear photo. We will arrange a replacement, refund or another fair solution as quickly as possible.</p></section>
        </article>
      </div>
    </main>
  );
}

export default Returns;
